import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import Label from "../Label";
import { filterTextField, normalizeTextField } from "utils/helpers/validations";

const Simple = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  trim = false,
  normalizeText = false,
  ...rest
}) => {
  const { onChange, onKeyUp, onBlur, onPaste, ...inputRest } = rest;

  const handleChange = (e) => {
    if (normalizeText) {
      const cleaned = filterTextField(e.target.value);
      if (cleaned !== e.target.value) {
        e = { ...e, target: { ...e.target, value: cleaned } };
      }
    }
    onChange?.(e);
  };

  const handleBlur = (e) => {
    if (normalizeText) {
      const cleaned = normalizeTextField(e.target.value);
      if (cleaned !== e.target.value) {
        e = { ...e, target: { ...e.target, value: cleaned } };
        onChange?.(e);
      }
    }
    onBlur?.(e);
  };

  return (
    <div
      className={classnames(
        "acoris__input",
        { "acoris__input--error": touched && errors },
        { "acoris__input--valid": touched && !errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="acoris__input--field">
        <Input
          className={classnames({
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          {...inputRest}
          onChange={handleChange}
          onKeyUp={(e) => {
            onKeyUp?.(e);
            if (!trim) return;
            const cleaned = e.target.value.replace(/\s+/g, "");
            if (cleaned === e.target.value) return;
            e.target.value = cleaned;
            onChange?.({ ...e, target: { ...e.target, value: cleaned } });
          }}
          onPaste={(e) => {
            onPaste?.(e);
            requestAnimationFrame(() => handleChange(e));
          }}
          onBlur={handleBlur}
        />
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

Simple.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Simple.defaultProps = {
  label: "",
  placeholder: "",
};
export default Simple;
